<template>
  <busqueda-de-pedidos>
  </busqueda-de-pedidos>
</template>

<script>
import BusquedaDePedidos from "./BusquedaDePedidos";
export default {
  name: "DashboardMain",
  components: {
    BusquedaDePedidos
  }
}
</script>

<style scoped>

</style>
